import observeAndExecute from "../utils/observe-and-execute";

class VueLoader {
    isLoaded = false;
    createApp = null;
    defineAsyncComponent = null;

    async loadVue() {
        if ( this.isLoaded ) return;
        const VUE = await import('vue');
        this.createApp = VUE.createApp;
        this.defineAsyncComponent = VUE.defineAsyncComponent;
        this.isLoaded = true;
    }
}

export default class VueComponents extends VueLoader {
    options = {
        spaces: "",
        components: [],
        watch: true,
    };

    constructor(options = {}) {
        super();
        this.options = { ...this.options, ...options };
        if (this.options.watch) this.watch();
    }

    async loadWithSpace() {
        await this.loadVue();
        const $VueApp = this.createApp({});

        for (const component of this.options.components) {
            $VueApp.component(component.name, this.defineAsyncComponent({
                loader: component.file,
            }));
        }

        $VueApp.mount(this.options.spaces);
    }

    async loadWithOutSpace() {
        await this.loadVue();

        for (const component of this.options.components) {
            document.querySelectorAll(`[data-vue-component="${component.name}"`).forEach((el) => {
                const $VueApp = this.createApp({});

                $VueApp.component(component.name, this.defineAsyncComponent({
                    loader: component.file,
                }));

                $VueApp.mount(el);
            });
        }
    }

    watch() {
        if ( this.options.spaces !== "" ) {
            let isLoad = false;
            observeAndExecute(`${this.options.spaces} [data-vue-component]`, {
                callback: async () => {
                    if ( isLoad ) return;
                    isLoad = true
                    this.loadWithSpace();
                },
                disconnect: true,
                observerOptions: this.options.observerOptions ?? {},
            })
        }
        else {
            for (const component of this.options.components) {
                observeAndExecute(`[data-vue-component="${component.name}"`, {
                    callback: async () => {
                        await this.loadVue();

                        document.querySelectorAll(`[data-vue-component="${component.name}"`).forEach((el) => {
                            const $VueApp = this.createApp({});

                            $VueApp.component(component.name, this.defineAsyncComponent({
                                loader: component.file,
                            }));

                            $VueApp.mount(el);
                        });
                    },
                    disconnect: true,
                    observerOptions: component.observerOptions ?? {},
                })
            }
        }
    }

    loadAllComponents() {
        if ( this.options.spaces !== "" ) {
            this.loadWithSpace();
        }
        else {
            this.loadWithOutSpace();
        }
    }
}